import React, { useEffect, useState } from 'react';
import './MultiInputField.scss';
import InputField from '../InputField/InputField';
import { Button, Chip, Stack } from '@mui/material';
import { copyDeep } from '../../../shared/utility';

const MultiInputField = props => {
  const { title, placeholder, onChange, defaultValue, width } = props;

  const [chipsData, setChipsData] = useState(
    defaultValue ? copyDeep(defaultValue) : []
  );

  const [inputValue, setInputValue] = useState('');

  const handleAddClicked = () => {
    if (!inputValue || inputValue == '') {
      return;
    }
    setChipsData(prev => {
      return [...prev, inputValue];
    });

    setInputValue('');
  };

  const handleDeleteChip = index => {
    setChipsData(prev => {
      const newData = [...prev];
      newData.splice(index, 1);
      return newData;
    });
  };

  useEffect(() => {
    onChange(chipsData);
  }, [chipsData]);

  return (
    <div className="chip-pane-container" style={{width: width}}>

      <div className="flex-row column-gap-medium">
        <InputField
          defaultValue={inputValue}
          title={title}
          placeholder={placeholder}
          onChange={value => setInputValue(value)}
          resetField={inputValue == ''}
          titlePosition="left"
        />
        <Button onClick={() => handleAddClicked()}>Add</Button>
      </div>
      <div>
        <Stack direction="row" spacing={1}>
          {chipsData.map((value, index) => {
            return (
              <Chip label={value} onDelete={() => handleDeleteChip(index)} />
            );
          })}
        </Stack>
      </div>
    </div>
  );
};

export default MultiInputField;
